import { render, staticRenderFns } from "./EC04TF.vue?vue&type=template&id=65d85e8e&"
import script from "./EC04TF.vue?vue&type=script&lang=js&"
export * from "./EC04TF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports